var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("summary-edit-col")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("app-column-select", {
                    attrs: {
                      "is-server-column": "",
                      "nummeric-only": "",
                      model: _vm.model,
                    },
                    model: {
                      value: _vm.selectedProp,
                      callback: function ($$v) {
                        _vm.selectedProp = $$v
                      },
                      expression: "selectedProp",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      attrs: { icon: "plus" },
                      on: {
                        click: function ($event) {
                          return _vm.addCol()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("add-property")))]
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("summary-pre-text") },
                    model: {
                      value: _vm.col.PreText,
                      callback: function ($$v) {
                        _vm.$set(_vm.col, "PreText", $$v)
                      },
                      expression: "col.PreText",
                    },
                  }),
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("summary-post-text") },
                    model: {
                      value: _vm.col.PostText,
                      callback: function ($$v) {
                        _vm.$set(_vm.col, "PostText", $$v)
                      },
                      expression: "col.PostText",
                    },
                  }),
                  _c(
                    "w-sortable",
                    {
                      attrs: {
                        tag: "w-list",
                        "target-class": "handle",
                        items: _vm.props,
                      },
                    },
                    _vm._l(_vm.props, function (prop, i) {
                      return _c(
                        "w-list-item",
                        { key: i, attrs: { "show-handle": "" } },
                        [
                          _c(
                            "w-list-item-action",
                            [
                              _c("w-select", {
                                attrs: { items: _vm.operators },
                                model: {
                                  value: prop.operator,
                                  callback: function ($$v) {
                                    _vm.$set(prop, "operator", $$v)
                                  },
                                  expression: "prop.operator",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("w-list-item-text", [
                            _vm._v(_vm._s(_vm.getPropText(prop))),
                          ]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("remove-item"),
                                      expression: "$ct('remove-item')",
                                    },
                                  ],
                                  staticClass: "danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeProp(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "trash" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }